module.exports = __webpack_public_path__ + "img/receipt.ee7186fe.svg";